import type React from 'react'

interface StrikePillProps {
    strike: number
    selected: boolean
    onToggle: () => void
    colorTheme: 'emerald' | 'rose'
}

export const StrikePill: React.FC<StrikePillProps> = ({ strike, selected, onToggle, colorTheme }) => {
    const activeClass =
        colorTheme === 'emerald'
            ? 'bg-emerald-500 text-white shadow-emerald-200 dark:shadow-emerald-900/20 shadow-sm ring-1 ring-emerald-500 ring-offset-1 dark:ring-offset-slate-900'
            : 'bg-rose-500 text-white shadow-rose-200 dark:shadow-rose-900/20 shadow-sm ring-1 ring-rose-500 ring-offset-1 dark:ring-offset-slate-900'

    return (
        <button
            onClick={onToggle}
            className={`px-2.5 py-1 rounded-md text-xs font-mono font-bold transition-all duration-200 grow-0 shrink-0 ${
                selected
                    ? activeClass
                    : 'bg-gray-50 dark:bg-slate-800 text-gray-500 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-700 border border-gray-100 dark:border-slate-700 hover:border-gray-300 dark:hover:border-slate-600'
            }`}
        >
            {strike}
        </button>
    )
}
